import { render } from "./PercentImage.vue?vue&type=template&id=e6f1ba70&scoped=true"
import script from "./PercentImage.vue?vue&type=script&lang=js"
export * from "./PercentImage.vue?vue&type=script&lang=js"

import "./PercentImage.vue?vue&type=style&index=0&id=e6f1ba70&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e6f1ba70"

export default script